import { cn } from '@/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

const badgeVariants = cva(
  'inline-flex items-center rounded-md px-2 py-0 pt-[1px] text-xs leading-[20px] font-medium ring-1 ring-inset',
  {
    variants: {
      variant: {
        default: 'bg-orange-default text-white ring-orange-default/10',
        secondary: 'bg-gray-50 text-gray-600 ring-gray-500/10',
        destructive: 'bg-red-50 text-red-700 ring-red-600/10',
        outline: 'text-gray-600 ring-1 ring-inset ring-gray-500/10',
        success: 'bg-green-50  ring-green-600/20',
        warning: 'bg-yellow-50 text-yellow-700 ring-yellow-600/20',
        info: 'bg-blue-50 text-blue-700 ring-blue-600/20',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
